export const foundationMotionTokens = {
  colors: 'transition-colors',
  emphasis: 'transition-all duration-200 ease-in-out',
  lift: 'transform hover:-translate-y-1',
  opacityFast: 'transition-opacity duration-150'
} as const;